export default __webpack_public_path__ + "static/media/benefit_13@2x.ea20c446.png";